import Vue from "vue"
import VueI18n from "vue-i18n"
import en from "./en"
import axios from "axios"
Vue.use(VueI18n)
export const messages = {
  en
}

const i18n = new VueI18n({
  locale: "en", // 设置语种
  messages, // 设置全局当地语言包,
  fallbackLocale: "en"
})

const loadedLanguages = ["en"] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang
  // axios.defaults.headers.common["Accept-Language"] = lang
  localStorage.setItem("language", lang)
  document.querySelector("html").setAttribute("lang", lang)
  return lang
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/${lang}/index.js`).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default)
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  })
}

const cache = localStorage.getItem("language")
if (cache) loadLanguageAsync(cache)

export default i18n
